
/*
 * ! @chakra-ui/vue v0.12.0 by Jonathan Bakebwa @codebender828
 * MIT License
 * https://github.com/chakra-ui/chakra-ui-vue
 */

import { D as extractListeners } from './index-2557a15f.js';
import './chakra-ui-styled-system.esm-36097b89.js';
import './internal-icons-b207e00d.js';
import '@emotion/css';
import 'vue';
import './color-mode-observer-d3e4ca7f.js';
import { C as CIcon } from './index-55a27cde.js';
import CPseudoBox from './CPseudoBox.js';
import { c as closeButtonProps, s as sizes, b as baseProps } from './closebutton.styles-8676783d.js';

/**
 * Hey! Welcome to @chakra-ui/vue CloseButton
 *
 * The CloseButton is essentially a button with a close icon.
 *
 * It is used to handle the close functionality in feedback
 * and overlay components like Alerts, Toasts, Drawers and Modals.
 *
 * @see Docs     https://vue.chakra-ui.com/closebutton
 * @see Source   https://github.com/chakra-ui/chakra-ui-vue/blob/master/packages/chakra-ui-core/src/CCloseButton/CCloseButton.js
 * @see A11y     https://github.com/chakra-ui/chakra-ui-vue/blob/master/packages/chakra-ui-core/src/CCloseButton/accessibility.md
 */
function objectWithoutProperties(obj, exclude) {
  var target = {};

  for (var k in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, k) && exclude.indexOf(k) === -1) target[k] = obj[k];
  }

  return target;
}
/**
 * CCloseButton component
 *
 * Component as button with close icon
 *
 * @extends CPseudoBox
 * @see Docs https://vue.chakra-ui.com/closebutton
 */

var CCloseButton = {
  name: 'CCloseButton',
  functional: true,
  inject: ['$chakraColorMode'],
  props: closeButtonProps,
  render: function render(h, context) {
    var props = context.props;
    var data = context.data;
    var injections = context.injections;
    var listeners = context.listeners;
    var rest$1 = objectWithoutProperties(context, ["props", "data", "injections", "listeners"]);
    var rest = rest$1;
    var colorMode = injections.$chakraColorMode(); // Pseudo styles

    var hoverColor = {
      light: 'blackAlpha.100',
      dark: 'whiteAlpha.100'
    };
    var activeColor = {
      light: 'blackAlpha.200',
      dark: 'whiteAlpha.200'
    }; // Size styles

    var buttonSize = sizes[props.size] && sizes[props.size].button;
    var iconSize = sizes[props.size] && sizes[props.size].icon; // Event listeners

    var nonNativeEvents = {
      click: function click(e) {
        var emitClick = context.listeners.click;

        if (emitClick) {
          emitClick(e);
        }
      }
    };
    var ref = extractListeners(context, nonNativeEvents);
    var native = ref.native;
    var nonNative = ref.nonNative;
    return h(CPseudoBox, Object.assign({}, rest, {
      props: {
        as: 'button'
      },
      on: nonNative,
      nativeOn: native,
      attrs: Object.assign({}, {
        'aria-label': props.ariaLabel,
        'aria-disabled': props.isDisabled,
        outline: 'none',
        h: buttonSize,
        w: buttonSize,
        disabled: props.isDisabled,
        cursor: 'pointer',
        _hover: {
          bg: hoverColor[colorMode]
        },
        _active: {
          bg: activeColor[colorMode]
        }
      }, baseProps, data.attrs, {
        'data-chakra-component': 'CCloseButton'
      })
    }), [h(CIcon, {
      props: {
        name: 'close',
        size: iconSize
      },
      attrs: {
        focusable: false,
        'aria-hidden': true
      }
    })]);
  }
};

export default CCloseButton;
